import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination } from '@mui/material';
import { useState } from 'react';
import ImagesDialog from './ImagesDialog';
import UpdatePayment from './updatePayment';
const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    { id: 'customerID', label: 'Customer ID', minWidth: 120 },
    { id: 'clientName', label: 'Client Name', minWidth: 120 },
    { id: 'customerLoginUserName', label: 'Customer LoginUsername', minWidth: 120 },
    { id: 'thirdPartyName', label: 'Third Party', minWidth: 120 },
    { id: 'statusName', label: 'Status', minWidth: 120 },
    { id: 'amount', label: 'Amount', minWidth: 120 },
    { id: 'unlockRequiredAmount', label: 'Unlock Required Amount', minWidth: 120 },
    { id: 'createdDate', label: 'Created Date', minWidth: 120, type: 'date' },
    { id: 'createdBy', label: 'Created By', minWidth: 120 },
    { id: 'updatedDate', label: 'Updated Date', minWidth: 120, type: 'date' },
    { id: 'updatedBy', label: 'Updated By', minWidth: 120 },
];

function StickyHeadTable({ payment, fetchPayment, thirdPartyList, statusList }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {payment.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <ImagesDialog imageUrl={row.imageUrl} />
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <UpdatePayment
                                                paymentList={row}
                                                fetchPayment={fetchPayment}
                                                thirdPartyList={thirdPartyList}
                                                statusList={statusList}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={payment.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
